module.exports = __webpack_public_path__ + "img/addr-icon.a9fe4490.svg";